// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-raccourcis {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.container-raccourcis-header {
  margin: 0.5em;
  display: flex;
  justify-content: space-between;
}

.container-raccourcis-body {
  display: block;
  overflow: auto;
  flex: 1 1;
  position: relative;
}

.container-raccourcis-body .table {
  width: 100%;
}

.container-raccourcis-body table {
  display: grid;
}

.container-raccourcis-body table tr {
  display: flex;
  width: 100%;
}

.container-raccourcis-body table th {
  font-size: 80%;
}

.container-raccourcis-body table th div {
  margin: auto;
}

.container-raccourcis-body table th .sort {
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.container-raccourcis-body table th,
.container-raccourcis-body table td {
  display: flex;
  padding-left: 10px;
}

.container-raccourcis-body table td button {
  width: 5em;
}

.container-raccourcis-header .search {
  margin: auto 0;
}

.container-raccourcis-header .checkbox-shortcut {
  margin: auto 0;
}

.container-raccourcis-header .checkbox-shortcut input {
  margin-right: 5px;
}

.container-raccourcis-header .checkbox-shortcut label {
  font-size: 14px;
  margin-right: 15px;
}

.container-raccourcis-header .group {
  display: flex;
  flex-direction: column;
  margin: auto 0;
}

.container-raccourcis-header .group label {
  font-size: 14px;
  margin-bottom: 5px;
}

.container-raccourcis-body input {
  height: 100%;
  margin: 0;
}

.footer {
  margin: auto;
  text-align: center;
  border-top: 1px solid lightgray;
  width: 100%;
  text-align: center;
}

.container-raccourcis-footer {
  border-top: 0.1em solid lightgray;
  padding: 0.5em;
}

.container-raccourcis-footer fieldset {
  border: none;
  margin: 0.5em;
}

.container-raccourcis-footer legend {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 1em;
}

.container-raccourcis-footer legend span {
  text-align: center;
  width: 60%;
  
}

.container-raccourcis-footer legend .control {
  font-size: 90%;
  margin: auto 0;
  width: 40%;
  text-align: right;
}

.container-raccourcis-footer legend .control input {
  vertical-align: middle;
  margin-right: 0.5em;
}

.container-raccourcis-footer form {
  justify-content: space-between;
}

.container-raccourcis-footer form .auto p {
  margin: 0;
  font-size: 0.8em;
}

.container-raccourcis-footer form .auto #txtShortcut {
  width: 250px;
  padding: 0.15em;
  background-color: white;
  color: black;
  border: none;
}

.container-raccourcis-footer form .actions {
  align-content: flex-end;
}

.container-raccourcis-footer form,
.container-raccourcis-footer form .controls {
  display: flex;
  flex-direction: row;
}

.container-raccourcis-footer form .control {
  margin-right: 0.5em;

  &:has(input[type='checkbox']) {
    label {
      margin-left: 0.5em;
      margin-right: 1em;
    }
  }

  &:has(input[type='text']) {
    label {
      margin-right: 0.5em;
    }
  }
}

.container-raccourcis-footer form input[type='text'] {
  width: 10em;
}

.container-raccourcis-footer form input[type='text'] {
  height: auto;
}

.container-raccourcis-footer form label {
  font-size: 0.8em;
}

.container-raccourcis-footer form button {
  margin-left: 1em;
  padding: 0.25em 0.5em;
  width: 5em;
}

.container-raccourcis-body table,
.container-raccourcis-body th {
  border: 1px solid lightgray;
  border-collapse: collapse;
}

.container-raccourcis-body th:has(.checkbox),
.container-raccourcis-body td:has(.checkbox) {
  width: 5%;
}

.container-raccourcis-body .checkbox,
.container-raccourcis-body .checkbox-cell {
  margin: auto;
}

.container-raccourcis-body td,
.container-raccourcis-body th {
  width: auto;
  box-sizing: border-box;
}

.container-raccourcis-body .key {
  font-size: 14px;
  overflow-wrap: anywhere;
  margin: auto 0;
}

/*les cellules checkbox */
.container-raccourcis-body td,
.container-raccourcis-body th {
  &:nth-child(1) {
    width: 1%;
  }

  &:nth-child(2) {
    width: 49%;
  }

  &:nth-child(3) {
    width: 30%;
  }

  &:nth-child(4) {
    width: 20%;
  }
}

.container-raccourcis-body tr:nth-child(even) {
  background-color: hsl(0, 0%, 15%);
}

.container-raccourcis-body th {
  text-align: center;
  padding: 2px 10px;
}

.container-raccourcis-body .column {
  display: inline-flex;
  margin: 0.5em 0;
  text-align: center;
}

.container-raccourcis-body .column p {
  margin: 0 1em;
}

.container-raccourcis-body table td:not(.editable) {
  font-size: 14px;
  padding: 1em;
  margin: auto;
}

.container-raccourcis-body .editable {
  background: initial;
  border: 0;
  color: white;
  font-family: 'Arial';
  font-size: 14px;
  margin: auto;
  width: 100%;
  padding: 0.25em 0.5em;
  margin-left: -10px;
  margin-top: -5px;
}

.container-raccourcis-body .editable-span {
  font-size: 14px;
  margin: auto 0;
  cursor: pointer;
}

.container-raccourcis-body .editable:focus {
  background-color: white;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/components/raccourcis/raccourcis.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;;AAEZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;;EAEnB;IACE;MACE,kBAAkB;MAClB,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;;EAEE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;;EAEE;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".container-raccourcis {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.container-raccourcis-header {\r\n  margin: 0.5em;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.container-raccourcis-body {\r\n  display: block;\r\n  overflow: auto;\r\n  flex: 1;\r\n  position: relative;\r\n}\r\n\r\n.container-raccourcis-body .table {\r\n  width: 100%;\r\n}\r\n\r\n.container-raccourcis-body table {\r\n  display: grid;\r\n}\r\n\r\n.container-raccourcis-body table tr {\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n\r\n.container-raccourcis-body table th {\r\n  font-size: 80%;\r\n}\r\n\r\n.container-raccourcis-body table th div {\r\n  margin: auto;\r\n}\r\n\r\n.container-raccourcis-body table th .sort {\r\n  user-select: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.container-raccourcis-body table th,\r\n.container-raccourcis-body table td {\r\n  display: flex;\r\n  padding-left: 10px;\r\n}\r\n\r\n.container-raccourcis-body table td button {\r\n  width: 5em;\r\n}\r\n\r\n.container-raccourcis-header .search {\r\n  margin: auto 0;\r\n}\r\n\r\n.container-raccourcis-header .checkbox-shortcut {\r\n  margin: auto 0;\r\n}\r\n\r\n.container-raccourcis-header .checkbox-shortcut input {\r\n  margin-right: 5px;\r\n}\r\n\r\n.container-raccourcis-header .checkbox-shortcut label {\r\n  font-size: 14px;\r\n  margin-right: 15px;\r\n}\r\n\r\n.container-raccourcis-header .group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: auto 0;\r\n}\r\n\r\n.container-raccourcis-header .group label {\r\n  font-size: 14px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.container-raccourcis-body input {\r\n  height: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.footer {\r\n  margin: auto;\r\n  text-align: center;\r\n  border-top: 1px solid lightgray;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.container-raccourcis-footer {\r\n  border-top: 0.1em solid lightgray;\r\n  padding: 0.5em;\r\n}\r\n\r\n.container-raccourcis-footer fieldset {\r\n  border: none;\r\n  margin: 0.5em;\r\n}\r\n\r\n.container-raccourcis-footer legend {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n  margin-bottom: 1em;\r\n}\r\n\r\n.container-raccourcis-footer legend span {\r\n  text-align: center;\r\n  width: 60%;\r\n  \r\n}\r\n\r\n.container-raccourcis-footer legend .control {\r\n  font-size: 90%;\r\n  margin: auto 0;\r\n  width: 40%;\r\n  text-align: right;\r\n}\r\n\r\n.container-raccourcis-footer legend .control input {\r\n  vertical-align: middle;\r\n  margin-right: 0.5em;\r\n}\r\n\r\n.container-raccourcis-footer form {\r\n  justify-content: space-between;\r\n}\r\n\r\n.container-raccourcis-footer form .auto p {\r\n  margin: 0;\r\n  font-size: 0.8em;\r\n}\r\n\r\n.container-raccourcis-footer form .auto #txtShortcut {\r\n  width: 250px;\r\n  padding: 0.15em;\r\n  background-color: white;\r\n  color: black;\r\n  border: none;\r\n}\r\n\r\n.container-raccourcis-footer form .actions {\r\n  align-content: flex-end;\r\n}\r\n\r\n.container-raccourcis-footer form,\r\n.container-raccourcis-footer form .controls {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.container-raccourcis-footer form .control {\r\n  margin-right: 0.5em;\r\n\r\n  &:has(input[type='checkbox']) {\r\n    label {\r\n      margin-left: 0.5em;\r\n      margin-right: 1em;\r\n    }\r\n  }\r\n\r\n  &:has(input[type='text']) {\r\n    label {\r\n      margin-right: 0.5em;\r\n    }\r\n  }\r\n}\r\n\r\n.container-raccourcis-footer form input[type='text'] {\r\n  width: 10em;\r\n}\r\n\r\n.container-raccourcis-footer form input[type='text'] {\r\n  height: auto;\r\n}\r\n\r\n.container-raccourcis-footer form label {\r\n  font-size: 0.8em;\r\n}\r\n\r\n.container-raccourcis-footer form button {\r\n  margin-left: 1em;\r\n  padding: 0.25em 0.5em;\r\n  width: 5em;\r\n}\r\n\r\n.container-raccourcis-body table,\r\n.container-raccourcis-body th {\r\n  border: 1px solid lightgray;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.container-raccourcis-body th:has(.checkbox),\r\n.container-raccourcis-body td:has(.checkbox) {\r\n  width: 5%;\r\n}\r\n\r\n.container-raccourcis-body .checkbox,\r\n.container-raccourcis-body .checkbox-cell {\r\n  margin: auto;\r\n}\r\n\r\n.container-raccourcis-body td,\r\n.container-raccourcis-body th {\r\n  width: auto;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.container-raccourcis-body .key {\r\n  font-size: 14px;\r\n  overflow-wrap: anywhere;\r\n  margin: auto 0;\r\n}\r\n\r\n/*les cellules checkbox */\r\n.container-raccourcis-body td,\r\n.container-raccourcis-body th {\r\n  &:nth-child(1) {\r\n    width: 1%;\r\n  }\r\n\r\n  &:nth-child(2) {\r\n    width: 49%;\r\n  }\r\n\r\n  &:nth-child(3) {\r\n    width: 30%;\r\n  }\r\n\r\n  &:nth-child(4) {\r\n    width: 20%;\r\n  }\r\n}\r\n\r\n.container-raccourcis-body tr:nth-child(even) {\r\n  background-color: hsl(0, 0%, 15%);\r\n}\r\n\r\n.container-raccourcis-body th {\r\n  text-align: center;\r\n  padding: 2px 10px;\r\n}\r\n\r\n.container-raccourcis-body .column {\r\n  display: inline-flex;\r\n  margin: 0.5em 0;\r\n  text-align: center;\r\n}\r\n\r\n.container-raccourcis-body .column p {\r\n  margin: 0 1em;\r\n}\r\n\r\n.container-raccourcis-body table td:not(.editable) {\r\n  font-size: 14px;\r\n  padding: 1em;\r\n  margin: auto;\r\n}\r\n\r\n.container-raccourcis-body .editable {\r\n  background: initial;\r\n  border: 0;\r\n  color: white;\r\n  font-family: 'Arial';\r\n  font-size: 14px;\r\n  margin: auto;\r\n  width: 100%;\r\n  padding: 0.25em 0.5em;\r\n  margin-left: -10px;\r\n  margin-top: -5px;\r\n}\r\n\r\n.container-raccourcis-body .editable-span {\r\n  font-size: 14px;\r\n  margin: auto 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.container-raccourcis-body .editable:focus {\r\n  background-color: white;\r\n  color: black;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
